/* LCT — Pages de politiques Shopify (/policies/...)
   Shopify génère ces pages sans modèle modifiable : on ajoute ici
   le fil d'Ariane, la date de mise à jour en évidence et un sommaire cliquable
   construit à partir des titres (H2 / H3) saisis dans Paramètres > Politiques. */
(() => {
    if (window.__lctPolicy) return;
    window.__lctPolicy = true;

    const slugify = (text, used) => {
        let slug = text
            .toLowerCase()
            .normalize('NFD')
            .replace(/[̀-ͯ]/g, '')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-|-$/g, '')
            .slice(0, 60) || 'section';
        let unique = slug;
        let i = 2;
        while (used.has(unique) || document.getElementById(unique)) unique = `${slug}-${i++}`;
        used.add(unique);
        return unique;
    };

    const init = () => {
        const container = document.querySelector('.shopify-policy__container');
        const titleBox = container?.querySelector('.shopify-policy__title');
        const body = container?.querySelector('.shopify-policy__body');
        if (!container || !body || container.classList.contains('lct-policy')) return;
        container.classList.add('lct-policy');

        const title = titleBox?.textContent.trim() || document.title;

        // 1. Fil d'Ariane
        const crumbs = document.createElement('nav');
        crumbs.className = 'lct-policy__crumbs';
        crumbs.setAttribute('aria-label', "Fil d'Ariane");
        crumbs.innerHTML = `<a href="${window.Shopify?.routes?.root || '/'}">Accueil</a><span aria-hidden="true">›</span><span></span>`;
        crumbs.lastElementChild.textContent = title;
        container.insertBefore(crumbs, container.firstChild);

        // 2. « Dernière mise à jour » sous le titre
        const rte = body.querySelector('.rte') || body;
        const first = rte.querySelector(':scope > p');
        if (first && /^derni[eè]re mise [àa] jour/i.test(first.textContent.trim())) {
            first.classList.add('lct-policy__updated');
            titleBox?.after(first);
        }

        // 3. Sommaire
        const headings = [...rte.querySelectorAll('h2, h3')].filter((h) => h.textContent.trim());
        const layout = document.createElement('div');
        layout.className = 'lct-policy__layout';
        body.before(layout);
        layout.appendChild(body);

        if (headings.length < 3) {
            layout.classList.add('lct-policy__layout--single');
            return;
        }

        const used = new Set();
        const list = document.createElement('ol');
        list.className = 'lct-policy__toc-list';
        let currentSub = null;
        headings.forEach((heading) => {
            if (!heading.id) heading.id = slugify(heading.textContent.trim(), used);
            const li = document.createElement('li');
            const link = document.createElement('a');
            link.href = `#${heading.id}`;
            link.textContent = heading.textContent.trim();
            link.dataset.target = heading.id;
            li.appendChild(link);
            if (heading.tagName === 'H3' && list.lastElementChild) {
                if (!currentSub || currentSub.parentElement !== list.lastElementChild) {
                    currentSub = document.createElement('ol');
                    list.lastElementChild.appendChild(currentSub);
                }
                li.className = 'is-sub';
                currentSub.appendChild(li);
            } else {
                currentSub = null;
                list.appendChild(li);
            }
        });

        const aside = document.createElement('aside');
        aside.className = 'lct-policy__toc';
        const details = document.createElement('details');
        details.innerHTML =
            '<summary><span>Sommaire</span><svg aria-hidden="true" focusable="false" viewBox="0 0 20 20" width="14" height="14"><path d="M5 7.5l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></summary>';
        details.appendChild(list);
        aside.appendChild(details);
        layout.insertBefore(aside, body);

        // Ouvert sur ordinateur, replié sur mobile
        const mq = window.matchMedia('(min-width: 990px)');
        const syncOpen = () => (details.open = mq.matches);
        syncOpen();
        mq.addEventListener('change', syncOpen);

        // Sur mobile, on replie le sommaire après un clic
        list.addEventListener('click', (event) => {
            if (event.target.closest('a') && !mq.matches) details.open = false;
        });

        // Lien actif pendant la lecture
        const links = new Map([...list.querySelectorAll('a')].map((a) => [a.dataset.target, a]));
        let active = null;
        const setActive = (id) => {
            if (active === id) return;
            active = id;
            links.forEach((a, key) => a.classList.toggle('is-active', key === id));
        };
        const onScroll = () => {
            const offset = 140;
            let current = headings[0].id;
            for (const heading of headings) {
                if (heading.getBoundingClientRect().top - offset <= 0) current = heading.id;
                else break;
            }
            setActive(current);
        };
        let ticking = false;
        window.addEventListener(
            'scroll',
            () => {
                if (ticking) return;
                ticking = true;
                requestAnimationFrame(() => {
                    onScroll();
                    ticking = false;
                });
            },
            { passive: true }
        );
        onScroll();
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();